'use client'

import { useMemo } from 'react'
import useSWR from 'swr'

import { ReserveFundQuery } from '../types/graphql/graphql'

interface UseReserveFund {
  isLoading: boolean
  totalReserveFundInUsd: number | undefined
  lastUpdated: string | undefined
}

export const useReserveFund = (): UseReserveFund => {
  const { data, isLoading } = useSWR<ReserveFundQuery>('/api/solvency/reserve-fund')

  const { lastUpdated, totalReserveFundInUsd } = useMemo(() => {
    if (!data?.queryIndex?.[0]?.yields?.length) {
      return { lastUpdated: undefined, totalReserveFundInUsd: undefined }
    }

    const yields = data.queryIndex[0].yields
    const lastItem = yields[yields.length - 1]

    return {
      lastUpdated: lastItem?.timestamp,
      totalReserveFundInUsd: lastItem?.value ?? 0,
    }
  }, [data])

  return { isLoading, lastUpdated, totalReserveFundInUsd } as UseReserveFund
}
